var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgApps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0h24v24H1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#475B7F",
    d: "M23.033 9.857l-4.168-7.143a1.45 1.45 0 00-2.5 0l-4.17 7.143c-.555.953.14 2.143 1.251 2.143h8.336c1.112 0 1.807-1.19 1.251-2.143z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F9BB3",
    d: "M7.99 12c1.324 0 2.593.527 3.529 1.464A5.006 5.006 0 0112.981 17c0 2.761-2.235 5-4.99 5C5.233 22 3 19.761 3 17s2.234-5 4.99-5zm13.723 1.25c.69 0 1.248.56 1.248 1.25v6.25c0 .69-.559 1.25-1.248 1.25h-6.237c-.69 0-1.248-.56-1.248-1.25V14.5c0-.69.559-1.25 1.248-1.25z"
  }))));
}

export default SvgApps;